import { defineCustomElement } from "vue";
import { Register } from "..";
import F360Tutorial from "./F360Tutorial.ce.vue";
import F360TutorialCarousel from "./F360TutorialCarousel.ce.vue";
import F360TutorialFechamentoCaixa from "./F360TutorialFechamentoCaixa.ce.vue";
import F360TutorialConciliacaoCartao from "./F360TutorialConciliacaoCartao.ce.vue";
import F360TutorialContasMovimento from "./F360TutorialContasMovimento.ce.vue";
import F360TutorialMinhaGestao from "./F360TutorialMinhaGestao.ce.vue";

const tutorials = [
  { tag: "vc-tutorial", component: F360Tutorial },
  { tag: "vc-tutorial-carousel", component: F360TutorialCarousel },
  {
    tag: "vc-tutorial-fechamento-caixa",
    component: F360TutorialFechamentoCaixa
  },
  {
    tag: "vc-tutorial-conciliacao-cartao",
    component: F360TutorialConciliacaoCartao
  },
  {
    tag: "vc-tutorial-contas-movimento",
    component: F360TutorialContasMovimento
  },
  { tag: "vc-tutorial-minha-gestao", component: F360TutorialMinhaGestao }
];

const _register: Register = {
  register() {
    tutorials.forEach(({ tag, component }) => {
      if (!customElements.get(tag)) {
        customElements.define(tag, defineCustomElement(component));
      }
    });
  }
};

export default _register;
